import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Menu from '../menu';
import { Constants, Globals } from '../../utils';
import { Auth } from '../../services';
import PlansImage from '../../assets/img/plans-image.png';
import LeftArrowIcon from '../../assets/icons/left-arrow.png';
import MenuWhatsappIcon from '../../assets/icons/pedidos_whatsapp.png';
import ArrowRightIcon from '../../assets/icons/arrow-right.png';

const MAX_ITEMS = 3;
const PLAN_TYPES = {
  MONTHLY: 0,
  ANNUAL: 1,
};
const PLANS = {
	CUSTOM: 0,
	FREE: 1,
	BASIC: 4,
	MEDIUM: 2,
	ADVANCED: 3,
};
const CUSTOM_PLAN = {
  id: PLANS.CUSTOM,
  name: 'Plan Personalizado',
  price: 0,
  price_year: 0,
  order: 99,
  image: 'img/plans/gear.png',
  details: [{ description: 'Puedes contactarnos y de acuerdo a tus requerimientos, ajustaremos un plan para ti.'}],
};

class Plans extends Component {

  state = {
    plans: [],
    filteredPlans: [],
    totalPages: 1,
    navButtons: [],
  }

  bScrollLeftRef = createRef();
  bScrollRightRef = createRef();

  componentDidMount() {
    this.load();
  }

  load = async () => {
    try {
      const res = await Auth.getPlans();
      const plans = res.plans?.concat(CUSTOM_PLAN) || [];
      await this.setState({ plans, filteredPlans: plans });
      this.scrollHorizontally(-1);
      // this.changePage();

    } catch (error) {
      console.log(error)
    }
  }

  changePage = (page = 1) => {
    const from = (page - 1) * MAX_ITEMS;
    const to = page * MAX_ITEMS;
    const filteredPlans = this.state.plans.slice(from, to);
    const totalPages = Math.ceil(this.state.plans.length / MAX_ITEMS);
    const navButtons = Array.from({ length: totalPages }, (_, i) => i + 1);
    this.setState({ page, filteredPlans, totalPages, navButtons });
  }

  scrollHorizontally = (val) => {
    const container = document.getElementById('plans');
    const el = document.getElementById('plans-carousel');
    let scrollAmount = container.clientWidth / 2;
    let maxScroll = el.scrollWidth - container.clientWidth;
    let currentScrollPosition = el.scrollLeft + (val * scrollAmount);

    if (currentScrollPosition < 0) {
      currentScrollPosition = 0;
      this.bScrollLeftRef.current.classList.add('invisible');
    } else {
      this.bScrollLeftRef.current.classList.remove('invisible');
    }

    if (currentScrollPosition >= maxScroll) {
      currentScrollPosition = maxScroll;
      this.bScrollRightRef.current.classList.add('invisible');
    } else {
      this.bScrollRightRef.current.classList.remove('invisible');
    }

    el.scrollTo({ left: currentScrollPosition, behavior: 'smooth' });
  }

  selectPlan = (plan, year) => {
    sessionStorage.setItem('planChange', JSON.stringify({ ...plan, year }));
    this.props.history.push(`/profile-business/payment`);
  }

  render() {
    return (
      <Menu
        history={this.props.history}
        leftSlot={<HeaderTitle onClick={() => this.props.history.goBack()} />}
        hideContentBreadcumbs
      >
        <div id="plans">
          <div className="plans-header">
            <div>
              <p className="slogan">¿Listo para mejorar la gestión financiera</p>
              <p className="sub-slogan">de tu negocio con Sysge24?</p>
            </div>
            <img className="plans-icon" src={PlansImage} alt="Plan" />
          </div>

          {/* <nav>
            {this.state.navButtons.map((item, index) => (
              <NavItem
                key={index}
                isSelected={this.state.page === item}
                onClick={() => this.changePage(item)}
              />
            ))}
          </nav> */}

          <main>
            <button className="controls-left invisible" ref={this.bScrollLeftRef} onClick={() => this.scrollHorizontally(-1)}>
              <img src={ArrowRightIcon} alt="Anterior" />
            </button>
            <button className="controls-right invisible" ref={this.bScrollRightRef} onClick={() => this.scrollHorizontally(1)}>
              <img src={ArrowRightIcon} alt="Siguiente" />
            </button>

            <div id="plans-carousel">
              {this.state.filteredPlans.map((plan, index) => (
                <PlanCard
                  key={index}
                  plan={plan}
                  onSelect={(period) => this.selectPlan(plan, period)}
                />
              ))}
            </div>
          </main>
        </div>
      </Menu>
    )
  }
}

// const NavItem = ({ isSelected, onClick }) => {
//   return (
//     <button
//       className={isSelected ? 'active' : ''}
//       onClick={onClick}
//     />
//   );
// }

const PlanCard = ({ plan, onSelect }) => {
  const isCustom = plan.id === PLANS.CUSTOM;

  const openWhatsApp = () => {
    const win = window.open(Constants.CUSTOM_PLAN_WHATSAPP_LINK, '_blank');
    win.focus();
  }

  return (
    <div className="plan" data-custom={isCustom ? 'true' : 'false'}>
      <div className="plan-header">
        <div className="plan-image">
          <img className="plan-icon" src={Globals.fromAssets(plan.image)} alt={plan.name} />
        </div>
        <div className="plan-resume">
          <p className="plan-name">{ plan.name }</p>
          <p>
            <span className="plan-price">${ Globals.formatMiles(plan.price) }</span>
            <span className="plan-period"> Mensual</span>
          </p>
        </div>
      </div>
      <div className="backtip">
        <div className="plan-details">
          <div className="plan-details-header">
            <span className="plan-annual-price">Precio anual: ${ Globals.formatMiles(plan.price_year) }</span>
          </div>
          <ul className="plan-features">
            {plan?.details?.map((d, dIdx) => (
              <li key={dIdx}>{ d.description }</li>
            ))}
          </ul>

          <div className="plan-actions">

            {isCustom ? (
              <button className="btn-whatsapp" onClick={openWhatsApp}>
                <img src={MenuWhatsappIcon} alt="WhatsApp" />
                <span>WhatsApp</span>
              </button>
            ) : (
              <>
                <button className="btn-green" onClick={() => onSelect(PLAN_TYPES.MONTHLY)}>
                  Seleccionar
                </button>

                <button className="btn-blue" onClick={() => onSelect(PLAN_TYPES.ANNUAL)}>
                  Plan Anual
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const HeaderTitle = ({ onClick }) => (
  <>
    <div className="back-button">
      <img src={ LeftArrowIcon } onClick={() => onClick()} alt="Regresar" />
    </div>
    <div className="content-breadcumbs" style={{ display: 'flex', alignItems: 'center' }}>
      <div className="title">Planes</div>
    </div>
  </>
)

export default connect(state => ({
  user: state.user,
}))(Plans)